import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { usageRightDefinition } from '../usage-right.definition'
import { usageRightYields } from '../usage-right.yields'
import { ChangeHistoryComponent } from 'src/app/components/change-history/change-history.component'
import { ActionDirective, EurosPipe, HasPermissionDirective, TruncatePipe } from 'src/app/abacus/standalone-exports'
import { CommonModule } from '@angular/common'
import { TableComponent } from 'src/app/abacus/elements/partials/table/table.component'
import { PaginationComponent } from 'src/app/abacus/elements/partials/pagination/pagination.component'
import { MetaComponent } from 'src/app/abacus/elements/partials/meta/meta.component'
import { CaseInputComponent } from 'src/app/abacus/elements/inputs/case-input/case-input.component'

@Component({
    template: caseListTemplate,
    standalone: true,
    imports: [
      CommonModule,
      RouterModule,
      TableComponent,
      EurosPipe,
      PaginationComponent,
      HasPermissionDirective,
      MetaComponent,
      CaseInputComponent
    ]
})
export class UsageRightListComponent
  extends CaseListComponent
  implements OnInit
{
  definition: ResourceDefinition = usageRightDefinition
  yields: Yield[] = usageRightYields

  filters: Filter[] = []

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
